import UIDs from "../../../../UIDs";

const uid = UIDs.screens.me.rewardPlanList;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    DELETE_REWARD_PLAN_ASYNC: `${uid}.deleteRewardPlanAsync`,
    DELETE_REWARD_PLAN_SUCCESS: `${uid}.deleteRewardPlanSuccess`,
    DELETE_REWARD_PLAN_FAILURE: `${uid}.deleteRewardPlanFailure`,
};

export { ActionTypes };